export const CURRENT = 'CURRENT'
export const PER_PAGE = 'PER_PAGE'
export const PAGE_CHANGE = 'PAGE_CHANGE'
export const RESET_PAGE = 'RESET_PAGE'
export const PaGINATION_DATA = 'PaGINATION_DATA'